import statusObject from '@/store/modules/pto/handbook/statusObject'
import statusProject from '@/store/modules/pto/handbook/statusProject'
import idHandbook from '@/store/modules/pto/handbook/idHandbook'
import documentFileType from '@/store/modules/pto/handbook/documentFileType'
import fotSurcharges from '@/store/modules/pto/handbook/fotSurcharges'
import сostPersonHour from '@/store/modules/pto/handbook/сostPersonHour'
import documentStatus from '@/store/modules/pto/handbook/documentStatus'
import jobType from '@/store/modules/pto/handbook/jobType'
import measureUnit from '@/store/modules/pto/handbook/measureUnit'
import nomenclatureStandard from '@/store/modules/pto/handbook/nomenclatureStandard'
import nomenclatureType from '@/store/modules/pto/handbook/nomenclatureType'
import statementType from '@/store/modules/pto/handbook/statementType'
import productType from '@/store/modules/pto/handbook/productType'
import productionType from '@/store/modules/pto/handbook/productionType'

export default {
  namespaced: true,
  modules: {
    statusObject,
    statusProject,
    idHandbook,
    documentFileType,
    fotSurcharges,
    сostPersonHour,
    documentStatus,
    jobType,
    measureUnit,
    nomenclatureStandard,
    nomenclatureType,
    statementType,
    productType,
    productionType
  }
}
